var CollectionView = require('views/base/collection-view');

var ActionPlanTopicResponsesCollectionView = CollectionView.extend({
  noWrap: false,
  autoRender: true,
  template: require('./templates/action-plan-topic-responses-collection'),
  listSelector: '.action-plan-topic-responses',
  itemView: require('./action-plan-topic-response-view'),
  animationDuration: 0,
  initItemView: function(model) {
    return new this.itemView({
      blockModel: this.model,
      autoRender: false,
      noWrap: true,
      model: model
    });
  },
  getTemplateData: Chaplin.View.prototype.getTemplateData
});

module.exports = ActionPlanTopicResponsesCollectionView;